import React, { Component }from "react";
import Tour from "react-user-tour";

import "./UserTour.css";

const title1 = (
  <div className="mb-5">
    <div style={{color: "rgb(35, 8, 78)", marginTop: 5, marginBottom: 2, marginLeft: 5}}>
      <p>Hi there!</p>
    </div>
    <div style={{marginLeft: 10} }>
      <p>
        Welcome to my homepage. I am so glad you decided to stop by <span style={{color: "purple"}}>&#10084;</span>.
      </p>
      <p>
        Click <strong style={{color: "rgb(35, 8, 78),  marginBottom: 5"}}>Next</strong> for a quick tour!
      </p>
    </div>
  </div>
);

const title2 =(
  <div>
    <div style={{color: "rgb(35, 8, 78)", marginTop: 1, marginBottom: 1, marginLeft: 10}}>
      <p>About Me</p>
    </div>
    <div style={{marginLeft: 10}}>
      <p>View my achievements and professional experience in Software Engineering and other fields.</p>
      <p>Get a feel of who I am as a person outside of work.</p>
      <p>What do I believe in?</p>
      <p>What do I do for fun?</p>
    </div>
  </div>
);

const title3 =(
  <div>
    <div style={{color: "rgb(35, 8, 78)", marginTop: 5, marginBottom:4, marginLeft: 10}}>
      <p>Drop me a line!</p>
    </div>
      <div style={{marginLeft: 10}}>
        <p>Feel free to reach out to me here.</p>
        <p>Tell me about your goals, your dreams.</p>
        <p>Share opportunities for growth, earning and learning.</p>
        <p>Or let's just have a conversation about life. </p>
        <p>Tour's over!</p>
        <p><strong style={{color: "rgb(35, 8, 78)"}}>Have fun exploring!&#10084;</strong></p>
        <br />
      </div>
  </div>
);

const bod = document.getElementById("mask-bg");

export default class UserTour extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTourActive: true,
      isSmallScreen: false,
      tourStep: 1,
      tourDelay: true
    };
    this.blurBack = this.blurBack.bind(this);
    this.cancelTour = this.cancelTour.bind(this);
    this.goNext = this.goNext.bind(this);
    this.goBack = this.goBack.bind(this);
  };
  
  componentDidMount() {
    this.handleScreenSize();
    window.addEventListener('resize', this.handleScreenSize);
    this.blurBack(bod);

    setTimeout(() => {
      this.setState({ tourDelay: false });
    }, 1000); 
    
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleScreenSize);
  }

  componentDidUpdate() {
    this.blurBack() && this.setState({tourStep: 2});
    
  }

  handleScreenSize = () => {
    this.setState({
      isSmallScreen: window.matchMedia('(max-width: 768px)').matches,
    });
  };

  blurBack() {
    let bod = document.getElementById("mask-bg");
    if(this.state.isTourActive && window.location.pathname ==='/') {
      bod.focus();
      bod.className +=" blur-background";
    } else {
      bod.classList.remove("blur-background");
    }
  }

  cancelTour() {
    this.setState({isTourActive: false}) 
  }

  goNext(step) {
    this.setState({tourStep: step})
  }

  goBack(step) {
    this.setState({tourStep: step})
  } 

  render() { 
    const { isTourActive, isSmallScreen, tourDelay } = this.state;
    const tourGuide = (
      <div id="user-tour">
        {isTourActive && !isSmallScreen && !tourDelay &&(<Tour
          active={this.state.isTourActive}
          step={this.state.tourStep}
          onNext={this.goNext}
          onBack={this.goBack}
          onCancel={this.cancelTour}
          steps={[
            {
              step: 1,
              selector: "#home-link",
              title: title1
            },
            {
              step: 2,
              selector: "#about-link",
              title: title2
            },
            {
              step: 3,
              selector: "#contact-link",
              title: title3
            },
          ]}
        />)}
      </div>
    )     
    return (
      window.location.pathname ==="/" ? tourGuide : 0
    );
  }
}
